// FlowKpiTile — a single KPI cell for the net_flow card. Models the PoC's
// `.kpi` tile (and the platform's MetricChip) in our tokens, adding an
// optional SIGN colour drawn from status.success / status.error
// (good/critical), NOT the flow buy/sell blue-red pair — a KPI delta is a
// value judgement, a flow bar is a direction, and the brief keeps those two
// colour vocabularies apart.

import { Box } from '@mui/material';

import { tokens } from '../../../../styles/tokens';
import { dilettaPanelSx } from '../../../../components/v2/widgets/exotics-shared/diletta-chrome';

export type KpiSign = 'positive' | 'negative' | 'neutral';

interface FlowKpiTileProps {
  label: string;
  value: string;
  sub?: string;
  sign?: KpiSign;
}

const signColor = (sign: KpiSign): string => {
  if (sign === 'positive') return tokens.status.success;
  if (sign === 'negative') return tokens.status.error;
  return tokens.text.primary;
};

export const FlowKpiTile = ({ label, value, sub, sign = 'neutral' }: FlowKpiTileProps) => {
  return (
    <Box
      sx={{
        // Platform widget chrome (blue-tinted translucent, #026aa2 border,
        // subtle shadow + blur) — same family as PP's index tiles, not the
        // PoC's near-black surface.
        ...dilettaPanelSx,
        padding: '13px 15px',
      }}
    >
      <Box
        sx={{
          fontSize: 10.5,
          color: tokens.text.muted,
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
        }}
      >
        {label}
      </Box>
      <Box
        sx={{
          fontSize: 24,
          fontWeight: 800,
          margin: '5px 0 2px',
          letterSpacing: '-0.5px',
          color: signColor(sign),
        }}
      >
        {value}
      </Box>
      {sub && <Box sx={{ fontSize: 10.5, color: tokens.text.muted }}>{sub}</Box>}
    </Box>
  );
};
